import { render } from "./Navigation.vue?vue&type=template&id=f2f0640e&scoped=true&ts=true"
import script from "./Navigation.ts?vue&type=script&lang=ts"
export * from "./Navigation.ts?vue&type=script&lang=ts"

import "./Navigation.scss?vue&type=style&index=0&id=f2f0640e&lang=scss&scoped=true"

import exportComponent from "/Users/koenverbruggen/Sites/02-SITES/nederlandsmijnmuseum.local/wp-content/themes/nmm/js/vue/nmm/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2f0640e"]])

export default __exports__